import { HttpService } from '@/shared/api/services/HttpService';
import { buildUrlForServiceName } from '@/connection/url-retriever';
import conf from '@/shared/config/useConfig';
import type { FilterOptionen } from '@/components/datatable/types/FilterObject.ts';
import type {
  MitteilungFilter,
  MitteilungFilterResponse,
} from '@/connection/filter-helper/filter-helper-mitteilungen.ts';
import type { Mitteilung, MitteilungTyp } from '@/types/Mitteilung.ts';

export class SharedMitteilungService extends HttpService {
  protected baseUrl = `${buildUrlForServiceName(
    conf.aufgabenserviceName,
  )}/aufgabenservice/api/private/v1`;

  async holeFilterOptionenMitteilungen(): Promise<FilterOptionen> {
    return this.httpClient.get(`${this.baseUrl}/mitteilungen/filteroptionen`);
  }

  async holeMitteilungenMitPaginierungUndFilterung(
    seite: number,
    seitengroesse: number,
    property: string,
    sortierArt: string,
    mitteilungFilter: MitteilungFilter,
  ): Promise<MitteilungFilterResponse> {
    return this.httpClient.post(`${this.baseUrl}/mitteilungen/filterung`, {
      params: { page: seite, size: seitengroesse, sort: `${property},${sortierArt}` },
      data: mitteilungFilter,
    });
  }

  async holeMitteilungenZuBuergschaft(
    buergschaftId: string,
    mitteilungTypIn: MitteilungTyp[],
  ): Promise<Mitteilung[]> {
    return this.httpClient.get(`${this.baseUrl}/mitteilungen/${buergschaftId}`, {
      params: { mitteilungTypIn },
    });
  }
}
